import ellipsize from 'ellipsize';
import TextEllipsize from './TextEllipsize';
import { removeTimeZoneOffset } from './dateFormatter';
import { format } from 'date-fns';
import { ROLES } from 'constant/enums';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { toPng } from 'html-to-image';

const nameRegex = /^[a-zA-ZÀ-ÿ ]+$/;
const isValidInteger = /^[0-9]+$/;
const charsToCheck = ['e', 'E', '-', '+'];
const phoneRegex = /^[0-9()\-+\s]+$/;
const charsToCheckForCalculator = ['e', 'E'];
const namesRegex = /^[a-zA-Z0-9-_,. ]+$/;

export const handleInputError = (input, errorMessage, setErrors) => {
  setErrors((prevState) => ({ ...prevState, [input]: errorMessage }));
};

export const trancateText = (text, maxChars = 25) => {
  return ellipsize(text, maxChars);
};

export const checkTextLength = (text, length) => {
  const trimText = text.trim();
  if (!text) {
    return false;
  }

  if (trimText.length > length) {
    return true;
  }
  return false;
};

//for minimum length
export const checkMinLength = (text, length) => {
  const trimmedText = text.trim();
  if (!text) {
    return false;
  }
  if (trimmedText.length < length) {
    return true;
  }
  return false;
};

export const checkInteger = (number) => {
  if (!number) {
    return false;
  }
  if (!isValidInteger.test(number)) {
    return true;
  }
};

export const isValidNumber = (value) => {
  return !(
    isNaN(value) ||
    value === '' ||
    value === Infinity ||
    value === -Infinity ||
    value === 'Infinity' ||
    value === '-Infinity'
  );
};

export const checkName = (name) => {
  if (!name) {
    return false;
  }
  if (!nameRegex.test(name)) {
    return true;
  }
};

//for product name
export const checkIsProductNameValid = (name) => {
  if (!name) {
    return false;
  }
  if (!namesRegex.test(name)) {
    return true;
  }
};

const customStyles = {
  viewColumns: {
    marginLeft: '50px !important' // Add your left margin here
  }
};

export const filterTable = {
  customStyles,
  filterType: 'dropdown',
  selectableRows: false,
  download: false,
  responsive: 'standard',
  fixedHeader: true,
  fixedSelectColumn: false

  //For future use
  // textLabels: {
  //   body: {
  //     noMatch: ''
  //   }
  // }
};

// for filters
export const tableOptionFilter = {
  ...filterTable,
  tableBodyHeight: '50vh',
  textLabels: {
    body: {
      noMatch: ' Sorry, no records found'
    },
    toolbar: {
      downloadCsv: 'Download'
    }
  }
};

// for no filters
export const tableOptions = {
  ...tableOptionFilter,
  download: false,
  print: false,
  search: false,
  viewColumns: false,
  filter: false
};

export const expandableTableOptions = {
  ...tableOptionFilter,
  tableBodyHeight: '64vh',
  selectableRows: false,
  expandableRows: true,
  expandableRowsHeader: false,
  expandableRowsOnClick: true,
  defaultExpanded: false
};

export const columOptions = {
  sort: false,
  filter: true,
  downloadOptions: {
    filename: 'excel-format.csv',
    separator: ';',
    filterOptions: {
      useDisplayedColumnsOnly: true,
      useDisplayedRowsOnly: true
    }
  },
  onDownload: (buildHead, buildBody, columns, data) => {
    if (this.state.downloadFile) {
      let val = `${buildHead(columns)}${buildBody(data)}`.trim();
      return val;
    }

    return false;
  },

  //For Future use
  // rowsPerPage: 100,
  // rowsPerPageOptions: [10, 100, 250, 500, 1000],
  // downloadOptions: {
  //   filename: 'excel-format.pdf',
  //   separator: ';'
  // },
  filterOptions: {
    renderValue: (item) => {
      if (typeof item === 'number') {
        return item !== undefined && item !== null ? item.toString() : '(empty)';
      } else {
        return item?.length ? <TextEllipsize value={item} /> : '(empty)';
      }
    }
  },
  customFilterListRender: (filterList) => {
    if (typeof filterList === 'number') {
      return filterList.toString();
    }
    return <TextEllipsize value={filterList} />;
  }
};

export const getFilteredValueByName = (array, name) => array.filter((arr) => arr.name === name);

export const detectBrowser = () => {
  const userAgent = window.navigator.userAgent;

  if (userAgent.includes('Edg')) {
    return 'Edge';
  } else if (userAgent.includes('Chrome')) {
    return 'Chrome';
  } else {
    return 'Unknown'; // Default to "Unknown" or handle other browsers as needed
  }
};

export const isNotAdmin = (roles) => {
  if (!roles) {
    return false;
  }
  if (roles[0] !== 'ROLE_SUPER_ADMIN' && roles[0] !== 'ROLE_ADMIN') {
    return true;
  }
  return false;
};

export const isSuperAdmin = (roles) => {
  if (!roles) {
    return false;
  }
  if (ROLES[roles[0]] === ROLES.ROLE_SUPER_ADMIN) {
    return true;
  }
  return false;
};

export const isAreaAdmin = (roles) => {
  if (!roles) {
    return false;
  }
  if (ROLES[roles[0]] === ROLES.ROLE_AREA_ADMIN) {
    return true;
  }
  return false;
};

export const isAdmin = (roles) => {
  if (!roles) {
    return false;
  }
  if (ROLES[roles[0]] === ROLES.ROLE_ADMIN) {
    return true;
  }
  return false;
};

export const isUser = (roles) => {
  if (!roles) {
    return false;
  }
  if (ROLES[roles[0]] === ROLES.ROLE_USER) {
    return true;
  }
  return false;
};

export const serverToClientDateConvertor = (serverDate) => {
  var serverDateObj = new Date(serverDate);
  var offset = serverDateObj.getTimezoneOffset();
  var newDate = new Date(serverDateObj - offset);
  return newDate;
};

export const isDateExpired = (date) => {
  const finalDate = new Date(removeTimeZoneOffset(date));
  const currDate = new Date();
  return currDate > finalDate;
};

/**
 * takes date object and converts into simple date string with no time zone information
 * to be added in db
 *
 * @param {Date} date
 * @returns date string
 */
export const formattedDateString = (date) => {
  const stringDate = removeTimeZoneOffset(date);
  const combinedString = format(new Date(stringDate), 'yyyy-MM-dd') + ' ' + '23:59:59';
  return combinedString;
};

/**
 * to check if a string is empty or full of white space
 *
 * @param {string} value
 * @returns true if string is not empty or spaces only
 */
export const isStringEmpty = (value) => {
  if (!value) return true;
  if (value?.length === 0) return true;
  if (value?.trim()?.length === 0) return true;
  return false;
};

export const isNumberEmpty = (value) => {
  return value?.length === 0 || value == null || value == undefined || isNaN(value);
};

export const isNegative = (value) => {
  return value < 0;
};

const getPrecisedValue = (value, precision) => parseFloat(value)?.toFixed(precision);

export const getOutputValue = (value, precision = 1, toCiel = true) => {
  if (value === '' || isNaN(value) || value == null) return '';
  return toCiel
    ? Math.ceil(getPrecisedValue(value, precision))
    : getPrecisedValue(value, precision);
};

//
/**
 * A function that converts a decimal number to a fraction
 *
 * @param {number} decimal
 * @returns {string} fraction
 */
const decimalToFraction = (decimal) => {
  // Find the greatest common divisor of the numerator and denominator
  const greatestCommonDivisor = (numerator, denominator) => {
    return denominator ? greatestCommonDivisor(denominator, numerator % denominator) : numerator;
  };
  // Multiply the decimal by a power of 10 to get the numerator
  let numerator = decimal * Math.pow(10, decimal.toString().length - 2);
  // The power of 10 is also the denominator
  let denominator = Math.pow(10, decimal.toString().length - 2);
  // Simplify the fraction by dividing both by the gcd
  const divisor = greatestCommonDivisor(numerator, denominator);
  numerator /= divisor;
  denominator /= divisor;
  // Return the fraction as a string
  return numerator / denominator == 0 ? '' : numerator + '/' + denominator;
};

/**
 * A function that formats a fraction according to the pattern
 *
 * @param {number} fraction
 * @param {string} pattern
 * @returns {string} formatted fraction
 */
const formatFraction = (fraction, pattern = '?/?') => {
  // Split the pattern by the slash
  let [numPattern, denPattern] = pattern.split('/');
  // Count the number of question marks in each part
  const numDigits = numPattern.length;
  const denDigits = denPattern.length;
  // Split the fraction by the slash
  let [numerator, denominator] = fraction.split('/');

  if (numerator == undefined || denominator == undefined) return '';

  // Pad the numerator and denominator with zeros to match the pattern length
  numerator = numerator.padStart(numDigits, '0');
  denominator = denominator.padStart(denDigits, '0');
  // Replace the question marks with the corresponding digits
  numPattern = numPattern.replace(/\?/g, (match, index) => numerator[index]);
  denPattern = denPattern.replace(/\?/g, (match, index) => denominator[index]);
  // Return the formatted fraction as a string
  return numPattern + '/' + denPattern;
};

/**
 * A function that takes a decimal number and a pattern and returns the formatted fraction
 *
 * @param {number} decimal
 * @param {string} pattern
 * @returns {string} formatted string containing fraction
 */
export const convertToFractionFormat = (decimal, pattern) => {
  if (decimal == '' || isNaN(decimal)) return '';
  // Convert the decimal to a fraction
  const fraction = decimalToFraction((decimal - Math.floor(decimal))?.toFixed(3));
  // Format the fraction according to the pattern
  const formatted = formatFraction(fraction, pattern);
  // Return the formatted fraction
  return `${parseFloat(decimal).toFixed(2)} (${Math.floor(decimal)} ${formatted}")`;
};

export const getArrayWithoutEmptyStrings = (list) => {
  const result = list?.filter((val) => val !== '');
  if (!result?.length) return [0];
  return result;
};

export const getIsAllArrayInValid = (list) => {
  if (typeof list != 'object') return true;
  const result = list?.filter((val) => val != Infinity && val != -Infinity && !isNaN(val));
  if (!result?.length) return true;
  else return false;
};

export const getIsAnyValueFalseOrInfinity = (list) => {
  if (typeof list != 'object') return true;
  return list?.some((value) => !value || value == Infinity || value == -Infinity || isNaN(value));
};

export const getIsAnyValueFalseOrInfinityExceptZero = (list) => {
  if (typeof list != 'object') return true;
  return list?.some(
    (value) => (!value && value != 0) || value == Infinity || value == -Infinity || isNaN(value)
  );
};

export const getIsInfinityOrError = (list) => {
  if (typeof list != 'object') return true;
  return list?.some((value) => value == Infinity || value == -Infinity || isNaN(value));
};

export const getDataBasedOnKey = (keyName, data) => {
  // Iterate over the keys of the object
  for (const key of Object.keys(data)) {
    // Split the key using '|' as the separator
    const keys = key.split('|');
    // Check if the input value matches any of the keys
    if (keys.includes(keyName)) {
      // Return the matched key
      return data[key];
    }
  }
};

export const isArrayEmpty = (arr) => {
  if (arr == null || arr == undefined || arr?.length == 0) {
    return true;
  }
  if (arr?.length > 0) {
    return false;
  }
};

/**
 * check length after decimal
 */
export const isPrecise = (number, length) => {
  if (!Number.isInteger(number) && number?.toString()?.split('.')[1]?.length > length) {
    return true;
  }

  if (Number.isInteger(number)) {
    return false;
  }
  if (number == null || number == undefined) {
    return false;
  }
};

/**
 * check length before decimal
 */
export const integerPartLengthExceeds = (number, length) => {
  if (Number?.isInteger(number) && number.length > length) {
    return true;
  }

  if (!Number.isInteger(number) && number?.toString()?.split('.')[0]?.length > length) {
    return true;
  }
  if (number == null || number == undefined) {
    return false;
  }
};

export const isValidPhone = (number) => {
  if (!number) {
    return false;
  }

  if (!phoneRegex.test(number)) {
    return true;
  }
};

// get key from object
export const getRolesKeyByValue = (value) => {
  return Object.keys(ROLES).find((key) => ROLES[key] === value);
};

export const preventChars = (event) => {
  charsToCheck.includes(event.key) && event.preventDefault();
};

export const preventCharsCal = (event) => {
  charsToCheckForCalculator.includes(event.key) && event.preventDefault();
};

export const preventDecimal = (event) => {
  event.key === '.' && event.preventDefault();
};

// to check error object if all the values now have undefined value
export const getAreAllErrorsGone = (errors) => {
  return Object.values(errors).every((value) => value === null || value === undefined);
};

export const handleDownload = (buildHead, buildBody, columns, data) => {
  // Generate PDF content using jsPDF
  const body = buildBody(data);
  const lines = body.split('\n');
  // Initialize an array to store the separated arrays
  const pdfRowBodyArrays = [];

  lines.forEach((line) => {
    // Remove double quotes and carriage return from the line
    const tableRow = line.replace(/"/g, '').replace(/\r/g, '');
    // Split the line by commas to separate the values
    const values = tableRow.split(',');
    pdfRowBodyArrays.push(values);
  });

  // For round the prices into 2 digit
  const roundedArrays = pdfRowBodyArrays.map((array) => {
    return array.map((item, index) => {
      if (index === 3 || index === 4) {
        return item === 'Call' ? 'Call' : parseFloat(item).toFixed(2);
      }
      // Otherwise, return the original item

      return item;
    });
  });

  const doc = new jsPDF();
  if (roundedArrays[0].length > 0) {
    roundedArrays[0].push('', 'No records found');
  }
  doc.setTextColor('#2980ba');
  doc.text('Price List ', 14, 10);
  const head = [buildHead(columns)];

  let cleanedString = head[0].trim().replace('\r\n', '');

  const cleanedArray = cleanedString.replace(/"/g, '').split(',');

  autoTable(doc, {
    head: [cleanedArray],
    body: roundedArrays
    // styles
  });

  // Trigger download of the PDF file
  doc.save('PriceList.pdf');
};

//For Calculator inputs
export const stylesInput = {
  '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0
  },
  '&': {
    '-moz-appearance': 'textfield' /* Firefox */,
    appearance: 'textfield' /* Standard */
  }
};

export const handleKeyDown = (e) => {
  if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
    e.preventDefault();
  }
};

//for image clicking issue
export const allowSecondClick = (lastClickTime, setLastClickTime) => {
  const currentTime = new Date().getTime();
  if (currentTime - lastClickTime < 800) {
    setLastClickTime(currentTime);
    return true;
  } else {
    setLastClickTime(currentTime);
    return false;
  }
};

//for navigation url
export const updateHistoryState = () => {
  let currentURL = window.location.href;
  const newURL = window.location.pathname + window.location.search + window.location.hash;
  if (newURL !== currentURL) {
    history.replaceState(null, '', newURL);
    currentURL = newURL;
  }
};

//For upperCase All and remove space (Tier 1 to TIER1)
export const formatTierName = (tierName) => {
  return tierName.replace(/\s+/g, '').toUpperCase();
};

//For upperCase first and other lowercase
//and add space between number and alphabet (TIER1  to Tier 1)
export const formatTier = (tier) => {
  let formatted = tier.charAt(0)?.toUpperCase() + tier.slice(1)?.toLowerCase();
  formatted = formatted?.replace(/(\d)/, ' $1');
  return formatted;
};

/**
 * This fucnctions creates a image of the provided element using id and save it in pdf
 * format
 *
 * @param {string} id It is the id of the elment needed to be captured
 * @param {number} width width of the content on pdf page
 * @param {number} height heght of the content on the pdf page
 */
export const saveScreenshot = (id, width, height, setShowLoader) => {
  const element = document.getElementById(id).shadowRoot || document.getElementById(id);
  toPng(element)
    .then((dataUrl) => {
      const img = new Image();
      img.src = dataUrl;
      const pdf = new jsPDF();
      pdf.addImage(img, 'PNG', 5, 5, width, height);
      pdf.save('results.pdf');
      setShowLoader(false);
    })
    .catch((error) => {
      console.error('oops, something went wrong!', error);
      setShowLoader(false);
    });
};

/**
 * To check if the object is empty as {}
 * or have no values against any key or have empty strings as values
 *
 * @param {object} obj any object
 * @returns true if object is empty or have no values against any key
 */
export const isObjectEmpty = (obj) => {
  if (typeof obj !== 'object' || obj === null) {
    console.error('Input must be a non-null object');
    return true;
  }

  return Object.values(obj).every((value) => value === undefined || value === null || value === '');
};

/**
 * to add percentage amount tot the total amount
 *
 * @param {number} value original amout
 * @param {number} percentage precentage
 * @returns value with added amount according to given ammount
 */
export const adjustByPercentage = (value, percentage) => {
  if (isNaN(percentage) || !percentage) return value;
  if (value == 0 || isNaN(value)) return 0.0;
  return (Number(value) + calculatePercentage(value, percentage)).toFixed(2);
};

/**
 * to get percentage amount of the original value
 *
 * @param {number} value original amount
 * @param {number} percentage percentage
 * @returns percentage amout
 */
export const calculatePercentage = (value, percentage) => {
  if (isNaN(percentage) || !percentage) return 0;
  return Number((value * (+percentage / 100)).toFixed(2));
};

export const getImageFile = (url) => {
  const byteString = atob(url.split(',')[1]);
  const mimeString = url?.split(',')[0]?.split(':')[1]?.split(';')[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([ab], { type: mimeString });
  return new File([blob], 'image.jpg', { type: 'image/jpg' });
};

export const getArrayOfValuesFromMap = (mapObject) => {
  if (!mapObject) return [];
  return [...mapObject.values()]?.map((obj) => obj.value);
};
